import published from 'utils/published'
import ChromeExtensionRequestor from './ChromeExtensionRequestor'

/**
 * This is used as a base service
 */

export default abstract class ChromeExtensionService {
  public currentUrl = published('')
  public requestor: ChromeExtensionRequestor

  abstract get serviceName(): string

  public get events() {
    return this.requestor.events.filter((e) => e && e.event?.itx === this.serviceName)
  }

  public constructor() {
    this.requestor = new ChromeExtensionRequestor()
    this.events.subscribe(async (item) => {
      // @ts-ignore
      if (item.event?.itx === this.serviceName && item.event?.method != null && this[item.event.method]) {
        // @ts-ignore
        const result = await this[item.event.method](item.event.payload)
        item.sendResponse(result)
      } else {
        item.sendResponse(null)
      }
    })
  }

  public getCurrentTab = async () => {
    const tabs = await this.requestor.exec('background', 'getTabs', {active: true, currentWindow: true})
    if (tabs && tabs.length) {
      return tabs[0]
    }
  }
}
